// extracted by mini-css-extract-plugin
module.exports = {"rating":"Ut-z"};